module.exports = __webpack_public_path__ + "static/phone-carrier-intro-circle-1-2a4ffd42214181962b8adafe4f984c4a.png";